<template>
  <div>
    <div class="robot" v-show="show" @click="handleOpenRobot">
      <img src="@/assets/jiopweb/robot.png" alt="">
      <span>智能导办</span>
    </div>
    <!-- <div id="robot"></div> -->
    <RobotHelper
      :robotRootId="robotRootId"
      :robotType="robotType"
      :eleId="'robotguideComplex'"
      :isVisible="isVisible"
      :itemBean="itemInfoBean"
      :taskServiceObj="serviceObjectName"
      :situationDataBeanList="situationDataBeanList"
      @closeRobot="closeRobot"
    />
    <GlobalHead @updateDetailSame="updateDetailSame" />
    <div class="allWrapper">
      <div class="guideHeader">
        <div class="guidHeaderMain">
          <div class="headLeft">
            <span class="formTitle">{{ itemInfoBean.deptName }}</span>
            <span class="title">{{ itemInfoBean.itemName }}</span>
            <span class="ownTitle">{{ serviceObjectName }}</span>
            <div class="titleBtn">
              <span class="btnStyle1" v-if="taskOnline === 'yes'" @click="toDealWith(itemInfoBean.itemName)">在线办理</span>
              <span class="btnStyle3" v-else>在线办理</span>
              <span class="btnStyle2" v-if="false">预约办理</span>
              <a-tooltip placement="top">
                <template slot="title">
                  <span>通过视频互动方式，由申请人员基于屏幕共享的方式，边问边办，帮助您完成办件的申报。</span>
                </template>
                <span class="btnStyle4" @click="helpMe('help')">帮我办 <a-icon type="info-circle" /></span>
              </a-tooltip>
              <a-tooltip placement="top">
                <template slot="title">
                  <span>依托音视频实时互动能力，将实体大厅“面窗”服务迁移至线上，由工作人员代替您完成办件的申报。</span>
                </template>
                <span class="btnStyle4" @click="helpMe('agency')">代我办 <a-icon type="info-circle" /></span>
              </a-tooltip>
              <span class="btnStyle4" @click="evaluate(itemInfoBean.itemName)">评价</span>
              <span class="btnStyle2" @click="toggleFavorite()">{{ favoriteText }}</span>
              <span style="font-size:16px;margin-left:16px;cursor: pointer;" @click="downGuide">
                <a-icon style="color:#1777ff" :component="IconDownload"></a-icon> 下载指南
              </span>
            </div>
          </div>
          <div class="headeRight">
            <div class="headRightTag">
              <span class="cont" v-if="itemInfoBean.taskCharge==='yes'">收费</span>
              <span class="cont" v-else>不收费</span>
              <span class="cont" v-if="itemInfoBean.taskType==='01' || itemInfoBean.taskType==='即办件'">即办件</span>
              <span class="cont" v-else>承诺件</span>
              <span class="cont" v-if="itemInfoBean.taskHandleNum===0">全程网办</span>
              <span class="cont" v-else>跑{{ itemInfoBean.taskHandleNum }}次</span>
            </div>
            <div class="workTime">
              <span class="workSpan">
                <div class="dayStyle">
                  <span class="dayStyleTime" v-if="itemInfoBean.taskLegalLimitType!=='inScene'">{{ itemInfoBean.taskLegalLimit }}</span>
                  <span class="dayStyleDesc" v-if="itemInfoBean.taskLegalLimitType==='day'">自然日</span>
                  <span class="dayStyleDesc" v-else-if="itemInfoBean.taskLegalLimitType==='month'">月</span>
                  <span class="dayStyleDesc" v-else-if="itemInfoBean.taskLegalLimitType==='inScene'">当场</span>
                  <span class="dayStyleDesc" v-else>工作日</span>
                </div>
                <div class="desStyle">法定办结时限</div>
              </span>
              <span class="workSpan">
                <div class="dayStyle">
                  <span class="dayStyleTime" v-if="itemInfoBean.taskPromiseLimitType!=='inScene'">{{ itemInfoBean.taskPromiseLimit }}</span>
                  <span class="dayStyleDesc" v-if="itemInfoBean.taskPromiseLimitType==='inScene'">当场</span>
                  <span class="dayStyleDesc" v-else>工作日</span>
                </div>
                <div class="desStyle">承诺办结时限</div>
              </span>
            </div>
            <span class="toOtherStyle" @click="toSimple">
              查看简洁版办事指南 >
            </span>

          </div>
        </div>
      </div>
      <div class="simpleMain">
        <div class="section1">
          <a-tabs default-active-key="1">
            <a-tab-pane key="1">
              <template slot="tab">
                <a style="font-size: 18px;color:#999;display: inline-block;padding:12px 16px" href="#eventMessage">事项信息</a>
              </template>
            </a-tab-pane>
            <a-tab-pane key="2">
              <template slot="tab">
                <a style="font-size: 18px;color:#999;display: inline-block;padding:12px 16px" href="#handleFlow">办理流程</a>
              </template>
            </a-tab-pane>
            <a-tab-pane key="3">
              <template slot="tab">
                <a style="font-size: 18px;color:#999;display: inline-block;padding:12px 16px" href="#matrialSection">办事材料</a>
              </template>
            </a-tab-pane>
            <a-tab-pane key="4">
              <template slot="tab">
                <a style="font-size: 18px;color:#999;display: inline-block;padding:12px 16px" href="#setRules">设定依据</a>
              </template>
            </a-tab-pane>
            <a-tab-pane key="5">
              <template slot="tab">
                <a style="font-size: 18px;color:#999;display: inline-block;padding:12px 16px" href="#commonQuestion">常见问题</a>
              </template>
            </a-tab-pane>
          </a-tabs>
        </div>
        <div class="section2">
          <div class="sectionLeft">
            <EventMessage v-if="showEvent" ref="eventMessage" style="margin-bottom:40px" :itemInfoBean="itemInfoBean"/>
            <PublicMessage v-else ref="eventMessage" style="margin-bottom:40px" :itemInfoBean="itemInfoBean"/>
            <HandleFlow id="handleFlow" style="margin-bottom:40px" :handleInfo="itemInfoBean.handleLinkEntities"/>
            <MatrialSection
              ref="matrialSection"
              id="matrialSection"
              v-if="itemInfoBean.itemMaterialEntities"
              :itemId="itemInfoBean.iid"
              :situationDataBeanList="situationDataBeanList"
              :situation="situation"/>
            <SetRules style="margin-top:40px" id="setRules" :basisInfo="itemInfoBean.legalBasisBeans || []" />
            <div class="commonQuestion" id="commonQuestion" style="width:800px;padding-bottom:20px">
              <div class="title">常见问题</div>
              <div style="margin-top:20px" v-for="(item) in itemInfoBean.questionAnswerEntities" :key="item.id">
                <div>
                  <div class="headerTitle">
                    <span style="flex: 12">{{ item.qsQuestion }}</span>
                    <span v-show="item.isAnswerShow" @click="answerShowChanges(item)" style="color:#999;font-size:14px;cursor: pointer;flex: 2">收起∧</span>
                    <span v-show="!item.isAnswerShow" @click="answerShowChanges(item)" style="color:#999;font-size:14px;cursor: pointer;flex: 2">展开∨</span>
                    <!-- <div style="float:right">

                    </div> -->
                  </div>
                  <transition>
                    <div v-show="item.isAnswerShow" style="font-size: 14px;color: #666666;padding-left:10px;margin-top:12px">
                      {{ item.qsAnswer }}
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
          <div class="sectionRight">
            <IsCharge style="margin-bottom:35px" v-if="itemInfoBean.taskCharge==='yes'" :type="'matter'" :message="itemInfoBean.taskChargeBasis" :chargeInfo="itemInfoBean.chargeInfoEntities"/>
            <Consulting style="margin-bottom:35px" :consultationList="consultationList" :complaintsList="complaintsList" :consultOption="consultOption" :complaintOption="complaintOption" />
            <HandlePlace
              style="margin-bottom:35px"
              :mapData="mapDomain"
              :placeId="itemInfoBean.placeId"
              :taskPlace="itemInfoBean.taskPlace"
              :taskHandleTime="itemInfoBean.taskHandleTime"
              :selectType="selectType"/>
          </div>
        </div>
      </div>
    </div>
    <!-- <GlobalFoot /> -->
    <h-download ref="hDownload" :hrefUrl="hrefUrl"></h-download>
    <!-- <FlowMessage ref="flowMessage" /> --> <!-- 不需要弹窗展示办理流程每一个步骤的详细数据 -->
    <a-modal v-model="draftVisible" :footer="null" :closable="false" width="420px" >
      <a-row style="padding:8px">
        <a-col :span="2" style="margin-right:8px"><a-icon type="exclamation-circle" style="color:#1890ff;font-size:22px" /></a-col>
        <a-col :span="20"><p class="info">您于{{ handling.ctime |timeTransfer }}保存了该事项的草稿，要继续编辑吗？</p></a-col>
      </a-row>
      <div style="text-align:right;">
        <a-button key="cancel" type="defult" style="margin-right:5px" @click="routingHop(itemId)">
          重新填报
        </a-button>
        <a-button key="submit" type="primary" @click="refill">
          继续编辑
        </a-button>
      </div>
    </a-modal>
    <a-modal :visible="visibleTip" title="提示" @ok="handleOk" @cancel="handleCancel">
      <a-row style="padding: 8px">
        <a-col :span="2" style="margin-right: 8px">
          <a-icon type="exclamation-circle" style="color: #1890ff; font-size: 22px" />
        </a-col>
        <a-col :span="20">
          <p class="info">您当前尚未登录，是否登录？</p>
        </a-col>
      </a-row>
    </a-modal>
    <!-- 用户须知弹窗 -->
    <UserNotice
      ref="UserNotice"
      :confirm="toVideoPage"
      :config="config"
      :meeting-params="meetingParams"
      :access-token="accessToken"
    />
  </div>
</template>

<script>
import GlobalHead from '@/views/layout/globalHead.vue'
// import GlobalFoot from '@/views/layout/globalFood.vue'
import IconDownload from '@ant-design/icons/svg/outline/download.svg?inline'
import messageIcon from '@/assets/jiopweb3.0.0/message.svg?inline'
import rigthIcon from './../../../assets/jiopweb3.0.0/you.svg?inline'
// import FlowMessage from './components/flowMessage.vue'
import MatrialSection from './components/matrialSection.vue'
import Consulting from './components/consulting.vue'
import HandlePlace from './components/handlePlace.vue'
import SetRules from './components/setRules.vue'
import IsCharge from './components/isCharge.vue'
import EventMessage from './components/eventMessage.vue'
import PublicMessage from './components/publicMessage.vue'
import HandleFlow from './components/handleFlow.vue'
import { HDownload } from 'jpaas-component'
import { jiopAPI } from '@/api/jiopweb/jiop'
import { jiopWebAPI } from '@/api/jiopweb/jiopweb'
import { timeTransfer } from '@/utils/timeUtil'
import { sm2 } from 'sm-crypto'
import RobotHelper from './components/robotHelper.vue'
export default {
  name: 'GuideComplex',
  components: {
    GlobalHead,
    // GlobalFoot,
    HDownload,
    // FlowMessage,
    MatrialSection,
    Consulting,
    HandlePlace,
    SetRules,
    IsCharge,
    EventMessage,
    HandleFlow,
    PublicMessage,
    RobotHelper
  },
  filters: {
    timeTransfer
  },
  data () {
    return {
      config: {},
      meetingParams: {},
      accessToken: '',
      visibleHelp: false,
      show: true,
      visibleTip: false,
      handling: { ctime: 1 },
      showEvent: true, // 判断是否是公共服务的事项信息
      hrefUrl: '',
      IconDownload,
      messageIcon,
      rigthIcon,
      itemId: '',
      itemInfoBean: {},
      consultationList: [],
      complaintsList: [],
      serviceObjectName: '',
      consultOption: [],
      complaintOption: [],
      serviceObject: [],
      draftVisible: false,
      visible: false,
      situationDataBeanList: [],
      situation: 'off',
      prikey: '5506c31374d5d8e9d79ba5ecc7cd1a7d60df3f7ef5fbb6865ccd9ce489751ac7',
      mapDomain: '',
      materialList: [],
      selectType: 'manual',
      itemInfoBeanlist: {},
      metaStyle: {},
      taskOnline: false,
      isFavorited: false, // 初始状态未收藏
      userType: '',
      isVisible: false,
      robotType: '3',
      robotRootId: '4tCE1OOnq4OU0DGGJ9aeM'
    }
  },
  created () {
    this.itemId = this.$route.query.itemId
    this.getItemBeanDetail()
    this.getSituation()
  },
  watch: {},
  mounted () {
    // const that = this
    // // 创建一个 MutationObserver 实例并定义回调函数
    // var observer = new MutationObserver(function (mutationsList, observer) {
    //   // 获取目标元素
    //   var targetElement = document.getElementById('robot')
    //   // 遍历每一个变化
    //   for (var mutation of mutationsList) {
    //     if (mutation.type === 'childList') {
    //       // 子元素发生变化
    //       if (targetElement.childElementCount && targetElement.childElementCount > 0) {
    //         that.show = false
    //       } else {
    //         that.show = true
    //       }
    //     }
    //   }
    // })

    // // 配置观察器以监视子元素的变化
    // var config = { childList: true, subtree: true }

    // // 启动观察器
    // observer.observe(document.getElementById('app'), config)
  },
  computed: {
    favoriteText () {
      // 根据isFavorited的值返回不同的文本
      return this.isFavorited ? '取消收藏' : '收藏'
    }
  },
  methods: {
    toVideoPage () {
      console.log('确认用户须知')
    },
    handleOpenRobot () {
      // const { itemName, taskHandleCode, districtId } = this.itemInfoBean
      // window.openDialog('robot', itemName, taskHandleCode, districtId, 'jiop')
      // window.openNewDialog('robot','OAy0BmlubzJiwvozkgW63','2')
      this.isVisible = true
      this.show = false
    },
    closeRobot () {
      this.isVisible = false
      this.show = true
    },
    getCookieData (cookieName) {
      try {
        var name = cookieName + '='
        var cookieMsg = document.cookie.replace(/%/g, '%25')
        var decodedCookie = decodeURIComponent(cookieMsg)
        var cookieArray = decodedCookie.split(';')
        for (var i = 0; i < cookieArray.length; i++) {
          var cookie = cookieArray[i]
          while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1)
          }
          if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length)
          }
        }
        return ''
      } catch (err) {
        console.log(err, 'cookieErr')
      }
    },
    // 切换区划时获取同名的单事项
    updateDetailSame (distinctId, districtName, sessionData) {
      jiopAPI.sanmeMatter({ districtId: distinctId, name: this.itemInfoBean.itemName }).then(res => {
        if (res.success) {
          if (!res.data.itemIds) {
            this.$message.warning('该区划下没有与当前事项同名的事项')
          } else {
            this.$router.push({ query: { itemId: '7279477040' } })
            sessionStorage.setItem('JIOP_AREA', sessionData)
            location.reload()
          }
        }
      })
    },

    helpMe (appType) {
      const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))
      if (userInfo.isLogin) {
        const params = {
          itemId: this.itemInfoBean.iid,
          itemName: this.itemInfoBean.itemName,
          applyType: appType
        }
        this.meetingParams = params
        const userParams = JSON.parse(userInfo.desensitizeUser)
        const userType = (this.getCookieData('userType') === 1 || parseInt(userParams.userType) === 1) ? 1 : 2
        this.config = { userType: userType, appType: 1 }
        this.accessToken = this.getCookieData('accessToken')
        const userInfoType = appType === 'help' ? 'yhxz' : 'yhxy'
        this.$refs.UserNotice.showModal(userInfoType)
        this.visibleTip = false
      } else {
        // 是否登录提示框（未登录）
        this.visibleTip = true
      }
    },
    toggleFavorite (name) {
      // 切换收藏状态，并且可以在这里执行进一步的操作，例如发送请求到服务器
      this.isFavorited = !this.isFavorited
    },
    // 在线办理
    toDealWith (name) {
      if (this.identityCheck(name)) {
        this.cleanSession()
        const that = this
        const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))
        const userParams = JSON.parse(userInfo.desensitizeUser)
        const userId = userParams.uid
        jiopWebAPI.queryDraft({ userId: userId, matterId: this.itemId }).then(res => {
          if (res.success) {
            if (res.data.draft.handling !== null && res.data.draft.metaStyle !== null) {
              const jsonHandling = sm2.doDecrypt(res.data.draft.handling.substring(2), that.prikey, 1)
              const jsonMetaStyle = sm2.doDecrypt(res.data.draft.metaStyle.substring(2), that.prikey, 1)
              that.handling = JSON.parse(jsonHandling)
              that.metaStyle = JSON.parse(jsonMetaStyle)
              that.materialList = res.data.draft.itemMaterialList || []
              that.draftVisible = true
              // that.routingHop(this.itemId)
            } else {
              that.routingHop(this.itemId)
            }
          }
        })
      }
    },
    // 获取matter数据并存入缓存
    // getItemBeanSimple (iid) {
    //   jiopAPI.findItemBeanSimple({ itemId: iid }).then(res => {
    //     if (res.success) {
    //       if (res.data.itemInfoBean) {
    //         this.itemInfoBean = res.data.itemInfoBean
    //         this.setMatterSession(res.data.itemInfoBean, res.data.reportConfigByIid, iid)
    //         // 判断是否有草稿
    //         this.getDraft(iid)
    //       }
    //     }
    //   })
    // },
    // 清除session
    cleanSession () {
      sessionStorage.removeItem(this.itemId + '_listOfSituations')
      sessionStorage.removeItem(this.itemId + '_model')
      sessionStorage.removeItem(this.itemId + '_infoStr')
      sessionStorage.removeItem(this.itemId + '_JiopwebReceive')
      sessionStorage.removeItem(this.itemId + '_JiopwebMaterial')
      // 清空智能填报缓存
      sessionStorage.removeItem(this.itemId + 'SmartFill')
    },
    getDraft (iid) {
      this.cleanSession()
      const that = this
      const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))
      const userParams = JSON.parse(userInfo.desensitizeUser)
      const userId = userParams.uid
      jiopWebAPI.queryDraft({ userId: userId, matterId: iid }).then(res => {
        if (res.success) {
          if (res.data.draft.handling && res.data.draft.metaStyle) {
            const jsonHandling = sm2.doDecrypt(res.data.draft.handling.substring(2), that.prikey, 1)
            const jsonMetaStyle = sm2.doDecrypt(res.data.draft.metaStyle.substring(2), that.prikey, 1)
            that.handling = JSON.parse(jsonHandling)
            that.metaStyle = JSON.parse(jsonMetaStyle)
            that.materialList = res.data.draft.itemMaterialList || []
            that.draftVisible = true
          } else {
            that.routingHop(iid)
          }
        }
      })
    },
    getSteps (iid) {
      jiopWebAPI.findReportConfigByIid({ itemid: iid }).then(res => {
        const fillingInstruction = res.data.data.fillingInstruction
        const situation = res.data.data.situation
        const formConfig = res.data.data.formConfig
        const uploadMaterial = res.data.data.uploadMaterial
        const pickupMethod = res.data.data.pickupMethod
        const inforMationConfirmed = res.data.data.inforMationConfirmed
        let total = 0
        if (fillingInstruction === 'on') {
          total++
        }
        if (situation === 'on') {
          total++
        }
        if (formConfig === 'on') {
          total++
        }
        if (uploadMaterial === 'on') {
          total++
        }
        if (pickupMethod === 'on') {
          total++
        }
        if (inforMationConfirmed === 'on') {
          total++
        }
        if (fillingInstruction === 'on') {
          const url = this.$router.resolve({ path: '/fillInstruction', query: { itemId: this.itemId, stepNo: 0, total: total, flowId: res.data.data.flowId } })
          window.open(url.href, '_blank')
        } else if (situation === 'on') {
          const url = this.$router.resolve({ path: '/selectSitution', query: { itemId: this.itemId, stepNo: 0, total: total, flowId: res.data.data.flowId } })
          window.open(url.href, '_blank')
        } else if (formConfig === 'on') {
          const url = this.$router.resolve({ path: '/matterForm', query: { itemId: this.itemId, stepNo: 0, total: total, flowId: res.data.data.flowId } })
          window.open(url.href, '_blank')
        } else if (uploadMaterial === 'on') {
          const url = this.$router.resolve({ path: '/uploadMaterial', query: { itemId: this.itemId, stepNo: 0, total: total, flowId: res.data.data.flowId } })
          window.open(url.href, '_blank')
        } else if (pickupMethod === 'on') {
          const url = this.$router.resolve({ path: '/receiveInfo', query: { itemId: this.itemId, stepNo: 0, total: total, flowId: res.data.data.flowId } })
          window.open(url.href, '_blank')
        } else if (inforMationConfirmed === 'on') {
          const url = this.$router.resolve({ path: '/confirmInfo', query: { itemId: this.itemId, stepNo: 0, total: total, flowId: res.data.data.flowId } })
          window.open(url.href, '_blank')
        }
      })
    },
    routingHop (iid) {
      this.getSteps(iid)
      this.draftVisible = false
    },
    setSessionData () {
      if (this.handling.situationSelect) {
        // 存入情形
        sessionStorage.setItem(this.itemId + '_listOfSituations', this.handling.situationSelect)
      }
      if (this.handling.model && this.metaStyle.formData) {
        // 存入表单
        sessionStorage.setItem(this.itemId + '_model', this.handling.model)
        sessionStorage.setItem(this.itemId + '_infoStr', this.metaStyle.formData)
      }
      // 存入上传材料(当上传材料发生改变时，后台清除已上传的材料，不需要前端比对)
      if (this.metaStyle && this.metaStyle.uploadMaterial) {
        sessionStorage.setItem(this.itemId + '_JiopwebMaterial', this.metaStyle.uploadMaterial)
      }
      if (parseInt(this.handling.receiveType) === 0 || parseInt(this.handling.receiveType) === 1) {
        // 存入取件方式
        const params = { receiveType: this.handling.receiveType }
        if (parseInt(this.handling.receiveType) === 1) {
          params.receiveUserName = this.handling.receiveUserName
          params.receivePhone = this.handling.receivePhone
          params.receiveDetailArea = this.handling.receiveDetailArea
          params.receiveArea = this.handling.receiveArea
        }
        sessionStorage.setItem(this.itemId + '_JiopwebReceive', JSON.stringify(params))
      }
    },
    // 继续编辑
    refill () {
      const that = this
      this.setSessionData()
      jiopWebAPI.findReportConfigByIid({ itemid: this.itemId }).then(res => {
        let total = 0
        const fillingInstruction = res.data.data.fillingInstruction
        const situation = res.data.data.situation
        const formConfig = res.data.data.formConfig
        const uploadMaterial = res.data.data.uploadMaterial
        const pickupMethod = res.data.data.pickupMethod
        const inforMationConfirmed = res.data.data.inforMationConfirmed
        const intelligentApproval = res.data.data.intelligentApproval ? res.data.data.intelligentApproval : 'off'
        const acceptFlowId = res.data.data.acceptFlowId
        const wholeIntelligentApproval = res.data.data.wholeIntelligentApproval ? res.data.data.wholeIntelligentApproval : 'off'
        const stepList = []
        if (fillingInstruction === 'on') {
          total++
          stepList.push({ name: 'fillInstruction', isOpen: false })
        }
        if (situation === 'on') {
          total++
          stepList.push({ name: 'selectSitution', isOpen: false })
        }
        if (formConfig === 'on') {
          total++
          stepList.push({ name: 'matterForm', isOpen: false })
        }
        if (uploadMaterial === 'on') {
          total++
          stepList.push({ name: 'uploadMaterial', isOpen: false })
        }
        if (pickupMethod === 'on') {
          total++
          stepList.push({ name: 'receiveInfo', isOpen: false })
        }
        if (inforMationConfirmed === 'on') {
          total++
          stepList.push({ name: 'confirmInfo', isOpen: false })
        }
        const stepNo = that.handling.steps
        const router = '/' + stepList[stepNo].name

        that.$router.push({
          path: router,
          query: {
            itemId: that.itemId,
            stepNo: stepNo,
            total: total,
            flagTag: '0',
            flowId: res.data.data.flowId,
            handleType: 'item',
            materialList: JSON.stringify(that.materialList),
            intelligentApproval: intelligentApproval,
            acceptFlowId: acceptFlowId,
            wholeIntelligentApproval: wholeIntelligentApproval
          }
        })
      })
      this.draftVisible = false
    },
    setMatterSession (itemInfoBean, reportConfigByIid, itemId) {
      // 获取tag对应关系
      const objNameList = []
      this.userType = this.itemInfoBean.taskServiceObj.split(',')
      this.serviceObject.forEach(val => {
        this.userType.forEach(v => {
          if (v === val.dictionaryCode) {
            objNameList.push(val.name)
          }
        })
      })
      this.serviceObjectName = objNameList.join('、')

      const obj = {}
      obj.tag = this.serviceObjectName
      obj.groupName = itemInfoBean.deptName
      obj.applyName = itemInfoBean.itemName
      obj.applySource = 'PC'
      obj.matterId = itemInfoBean.iid
      obj.matterName = itemInfoBean.itemName
      obj.taskCode = itemInfoBean.taskCode
      obj.code = '11'
      obj.flowId = reportConfigByIid.flowId
      obj.metaId = reportConfigByIid.metaId
      const matter = JSON.stringify(obj)
      sessionStorage.setItem(itemId + '_matter', matter)
    },
    // 校验是否登录，若已登录校验是个人还是法人，未登录去登录
    identityCheck (name) {
      if (sessionStorage.getItem('JiopUserInfo')) {
        const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))
        if (userInfo.isLogin) {
          const userParams = JSON.parse(userInfo.desensitizeUser)
          const userType = (this.getCookieData('userType') === 1 || parseInt(userParams.userType) === 1) ? 'personal' : 'legalperson'
          if ((this.userType.indexOf('01') === -1 && userType === 'personal') || (this.userType.indexOf('02') === -1 && this.userType.indexOf('03') === -1 && this.userType.indexOf('04') === -1 && this.userType.indexOf('05') === -1 && userType === 'legalperson')) {
            const type = userType === 'legalperson' ? '个人' : userType === 'personal' ? '法人' : this.personOneThing ? '个人' : '法人'
            this.$info({
              title: `该事项仅限${type}账户办理`,
              content: (<div>您不是{name}的服务对象<br/>请登录{ type }账户再来吧</div>),
              onCancel () {

              }
            })
            return false
          } else {
            return true
          }
        } else {
          // 是否登录提示框（未登录）
          this.visibleTip = true
          return false
        }
      } else {
        // 是否登录提示框（未登录）
        this.visibleTip = true
        return false
      }
    },
    handleOk () {
      this.visibleTip = false
      this.toLoginPage()
    },
    handleCancel () {
      this.visibleTip = false
    },
    toLoginPage () {
      const params = this.$route.query || {}
      params.jiopWorkUrl = 'jiopweb/' + this.$route.name
      jiopWebAPI.getLoginUrl({ params: JSON.stringify(params) }).then(res => {
        if (res.success) {
          if (res.data.url) {
            window.location.href = res.data.url
          }
        }
      })
    },
    // 查询维度数据
    findOptionList (paramter) {
      jiopAPI.findOption(Object.assign({ type: paramter })).then(res => {
        if (res.success) {
          this.serviceObject = res.data.data.serviceObject ? res.data.data.serviceObject : []
          if (res.data.data.materialType) {
            this.$refs.matrialSection.materialTypeMeta = res.data.data.materialType
          }
          if (res.data.data.materialForm) {
            this.$refs.matrialSection.materialFromMeta = res.data.data.materialForm
          }
          if (res.data.data.sourceChannels) {
            this.$refs.matrialSection.sourceChannelsMeta = res.data.data.sourceChannels
          }
          if (res.data.data.materialNecessity) {
            this.$refs.matrialSection.materialNecessityMeta = res.data.data.materialNecessity
          }
          if (res.data.data.consultationMethod) {
            this.consultOption = res.data.data.consultationMethod
          }
          if (res.data.data.complaintMethod) {
            this.complaintOption = res.data.data.complaintMethod
          }
        }
      })
    },
    // 获取情形是否开启
    getSituation () {
      jiopWebAPI.findReportConfigByIid({ itemid: this.itemId }).then(res => {
        if (res.success) {
          this.situation = res.data.data.situation
        }
      })
    },
    // 查询事项信息
    getItemBeanDetail () {
      const that = this
      jiopAPI.findItemBeanDetail({ iid: this.itemId }).then(res => {
        if (res.success) {
          if (res.data.itemInfoBean) {
            this.taskOnline = res.data.itemInfoBean.taskOnline
            this.itemInfoBeanlist = res.data.itemInfoBean
            this.mapDomain = res.data.itemInfoBean.mapData
            this.itemInfoBean = res.data.itemInfoBean || {}
            that.selectType = that.itemInfoBean.selectType
            this.findOptionList('materialNecessity,serviceObject,consultationMethod,complaintMethod,,materialType,materialForm,sourceChannels')
            this.$nextTick(() => {
              this.$refs.matrialSection.getStartData(this.itemInfoBean.itemMaterialEntities || [])
            })
            this.situationDataBeanList = res.data.situationDataBeanList || []
            // 获取matter数据并存入缓存
            this.setMatterSession(res.data.itemInfoBean, res.data.reportConfigByIid, this.itemId)
            if (this.itemInfoBean.itemType === '20') {
              this.showEvent = false
            } else {
              this.showEvent = true
            }
            this.$nextTick(() => {
              if (res.data.itemInfoBean) {
                this.$refs.eventMessage.itemInfoBean = res.data.itemInfoBean
              }
            })
            this.itemInfoBean.questionAnswerEntities = this.itemInfoBean.questionAnswerEntities.map(item => {
              item.isAnswerShow = false
              return item
            })
            if (this.itemInfoBean.consultationComplaintsEntities) {
              this.itemInfoBean.consultationComplaintsEntities.forEach(item => {
                if (item.type === '0') {
                  this.consultationList.push(item)
                }
                if (item.type === '1') {
                  this.complaintsList.push(item)
                }
              })
              const array = JSON.parse(JSON.stringify(this.consultationList))
              let methodDescHotline = ''
              let methodDescAddress = ''
              this.consultationList.forEach(item => {
                if (item.methodName === 'consultationHotline') {
                  methodDescHotline = methodDescHotline + item.methodDesc + ','
                  array.splice(array.findIndex(e => e.iid === item.iid), 1)
                } else if (item.methodName === 'consultationAddress') {
                  methodDescAddress = methodDescAddress + item.methodDesc + ','
                  array.splice(array.findIndex(e => e.iid === item.iid), 1)
                }
              })
              methodDescHotline = methodDescHotline.substring(0, methodDescHotline.length - 1)
              methodDescAddress = methodDescAddress.substring(0, methodDescAddress.length - 1)
              if (methodDescHotline) {
                const params = { methodName: 'consultationHotline', methodDesc: methodDescHotline }
                array.push(params)
              }
              if (methodDescAddress) {
                const params = { methodName: 'consultationAddress', methodDesc: methodDescAddress }
                array.push(params)
              }
              this.consultationList = array
              // 投诉结构修改
              const arraycomplain = JSON.parse(JSON.stringify(this.complaintsList))
              let methodDescComplainPhone = ''
              let methodDescComplainAddress = ''
              this.complaintsList.forEach(item => {
                if (item.methodName === 'complaintHotline') {
                  methodDescComplainPhone = methodDescComplainPhone + item.methodDesc + ','
                  arraycomplain.splice(arraycomplain.findIndex(e => e.iid === item.iid), 1)
                } else if (item.methodName === 'complaintAddress') {
                  methodDescComplainAddress = methodDescComplainAddress + item.methodDesc + ','
                  arraycomplain.splice(arraycomplain.findIndex(e => e.iid === item.iid), 1)
                }
              })
              methodDescComplainPhone = methodDescComplainPhone.substring(0, methodDescComplainPhone.length - 1)
              methodDescComplainAddress = methodDescComplainAddress.substring(0, methodDescComplainAddress.length - 1)
              if (methodDescComplainPhone) {
                const params = { methodName: 'complaintHotline', methodDesc: methodDescComplainPhone }
                arraycomplain.push(params)
              }
              if (methodDescComplainAddress) {
                const params = { methodName: 'complaintAddress', methodDesc: methodDescComplainAddress }
                arraycomplain.push(params)
              }
              this.complaintsList = arraycomplain
            }
            this.$route.query.showRobot && this.handleOpenRobot()
          }
        }
      })
    },
    answerShowChanges (value) {
      this.itemInfoBean.questionAnswerEntities = this.itemInfoBean.questionAnswerEntities.map(item => {
        if (item.iid === value.iid) {
          item.isAnswerShow = !item.isAnswerShow
        }
        return item
      })
    },
    toSimple () {
      this.$router.push({ path: '/guideSimple', query: { itemId: this.itemId, bannerType: this.$route.query.bannerType } })
    },
    // 下载指南
    downGuide () {
      this.hrefUrl = '/api-gateway/jpaas-jiop-web-server/interface/guide/download?iid=' + this.itemId
      this.$refs.hDownload.download()
    },

    evaluate (name) {
      const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))
      if (userInfo.isLogin) {
        window.evaluate({
          params: {
            'title': '评价办事指南',
            'taskCode': '123',
            'evaCode': '', //  先不传
            'uuid': this.getCookieData('accessToken'), // token
            'proTaskHandleItem': this.itemInfoBeanlist.taskHandleCode, // 事项编码
            'taskName': this.itemInfoBeanlist.itemName, // 事项名称
            'projectNo': this.itemInfoBeanlist.taskHandleCode, // 事项编码
            'areaCode': this.itemInfoBeanlist.districtCode, // 区划id
            'pf': '1', // 1
            'proDepart': this.itemInfoBeanlist.deptName, // 事项部门
            'proDepartCode': this.itemInfoBeanlist.deptCode, // 来源部门编码
            'applicationName': '一网通办政务服务网',
            'evaType': '1',
            'ywName': this.itemInfoBeanlist.itemName,
            'userType': this.itemInfoBeanlist.taskServiceObj === '01' ? '1' : '2'
          }
        })
      } else {
        // 是否登录提示框（未登录）
        this.visibleTip = true
      }
    }
    // flowSeeOpen () {
    //   this.$refs.flowMessage.open()
    // }
  }
}
</script>

<style lang="less" scoped>
.robot {
  position: fixed;
  z-index: 999;
  right: 12px;
  top: 50%;
  transform: translateY(-30px);
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  color: #1777ff;
  cursor: pointer;
  img {
    width: 30px;
    margin-bottom: 4px;
  }
}
::v-deep .ant-tabs-nav .ant-tabs-tab-active a {
  color: #1890ff !important;
}
::v-deep .ant-tabs-nav .ant-tabs-tab {
  padding: 0 0 !important;
}
.v-enter,
.v-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
.v-enter-active,
.v-leave-active {
  transition: all 0.4s ease;
}
.allWrapper {
  .guideHeader {
    padding-top: 25px;
    box-sizing: border-box;
    height: 300px;
    background-image: url('~@/assets/jiopweb3.0.0/guide.png');
    .guidHeaderMain {
      width: 1200px;
      margin: 0 auto;
      .headLeft {
        float: left;
        width: 50%;
        .formTitle {
          font-size: 16px;
          color: #666666;
          line-height: 30px;
          height: 30px;
          display: inline-block;
          padding: 0 10px;
          background-image: linear-gradient(270deg, #f3f7ff 0%, #c8ddfb 99%);
          border-radius: 18px;
          margin-top: 28px;
        }
        .title {
          display: block;
          margin-top: 14px;
          font-size: 40px;
          line-height: 40px;
          color: #333333;
          font-weight: bold;
        }
        .ownTitle {
          display: block;
          margin-top: 8px;
          font-size: 14px;
          color: #333333;
        }
        .titleBtn {
          display: flex;
          align-items: center;
          margin-top: 24px;
          .btnStyle2 {
            height: 40px;
            width: 110px;
            margin-left: 20px;
            line-height: 40px;
            text-align: center;
            border: 1px solid rgba(23, 119, 255, 1);
            border-radius: 4px;
            cursor: pointer;
            display: inline-block;
            font-size: 14px;
            color: #1777ff;
          }
          .btnStyle1 {
            height: 40px;
            display: inline-block;
            width: 110px;
            color: #fff;
            background: #1777ff;
            line-height: 40px;
            text-align: center;
            border: 1px solid #fff;
            border-radius: 4px;
            cursor: pointer;
            font-size: 14px;
          }
          .btnStyle3 {
            height: 40px;
            display: inline-block;
            width: 110px;
            color: #fff;
            background: #888888;
            line-height: 40px;
            text-align: center;
            border: 1px solid #fff;
            border-radius: 4px;
            font-size: 14px;
          }
          .btnStyle4 {
            height: 40px;
            display: inline-block;
            width: 80px;
            color: #fff;
            background: #1777ff;
            line-height: 40px;
            text-align: center;
            border: 1px solid #fff;
            border-radius: 4px;
            font-size: 14px;
            cursor: pointer;
          }
        }
      }
      .headeRight {
        float: right;
        width: 50%;
        text-align: right;
        .headRightTag {
          margin-top: 20px;
          .cont {
            display: inline-block;
            line-height: 40px;
            text-align: center;
            width: 100px;
            height: 40px;
            font-size: 16px;
            color: #333333;
            font-weight: bold;
            margin-left: 20px;
            border: 1px solid rgba(22, 119, 255, 1);
            border-radius: 25px;
          }
        }
        .workTime {
          margin-top: 16px;
          .workSpan {
            display: inline-block;
            margin-left: 12px;
            margin-right: 8px;
            .dayStyle {
              .dayStyleTime {
                font-size: 28px;
                color: #1677ff;
                letter-spacing: 0;
                line-height: 28px;
                font-weight: 700;
              }
              .dayStyleDesc {
                margin-left: 8px;
                font-size: 16px;
                color: #333333;
                letter-spacing: 0;
                line-height: 16px;
                font-weight: 500;
              }
            }
            .desStyle {
              margin-top: 6px;
              font-size: 14px;
              color: #999999;
              letter-spacing: 0;
              line-height: 14px;
              font-weight: 400;
            }
          }
        }
        .toOtherStyle {
          margin-top: 16px;
          cursor: pointer;
          display: inline-block;
          width: 219px;
          height: 60px;
          background-image: linear-gradient(135deg, #f1f6f8 0%, #feffff 100%);
          border: 3px solid rgba(255, 255, 255, 1);
          box-shadow: 0px 4px 14px 0px rgba(181, 211, 229, 0.6);
          border-radius: 8px;
          font-size: 16px;
          line-height: 54px;
          text-align: center;
          color: #1777ff;
        }
      }
    }
  }
  .commonQuestion {
    margin-top: 40px;
    .title {
      font-size: 22px;
      color: #333333;
      font-weight: 500;
    }
    .headerTitle {
      color: #333;
      font-weight: bold;
      line-height: 40px;
      font-size: 16px;
      padding-left: 10px;
      background-image: linear-gradient(270deg, rgba(196, 210, 240, 0) 0%, #dfe7fa 100%);
      border-radius: 4px;
      padding-right: 10px;
      display: flex;
      justify-content: space-between;
    }
  }
  .simpleMain {
    width: 1200px;
    margin: 0 auto;
    .section2 {
      overflow: hidden;
      margin-top: 40px;
      .sectionLeft {
        float: left;
        width: 800px;
        margin-bottom: 15px;
        .resultStyle {
          margin-top: 40px;
          .title {
            font-size: 22px;
            color: #333333;
            font-weight: 500;
          }
          .textFlow {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
          .swiper-slide {
            cursor: pointer;
          }
        }
      }
      .sectionRight {
        float: right;
        width: 360px;
      }
    }
  }
}
</style>
